
import filter from "./filter"
import stats from "./stats"
import create from "./create"
import del from "./del"
import show from "./show"
import list from "./list"
import affectation from "./affectation"

export default  {
    namespaced:true,
    modules:{
       stats,
       filter,
       create,
       del,
       list,
       show,
       affectation
    }
}